import { useAppState } from "@/stores/app-state";
import { useMenuInfoStore } from "@/stores/menu-info";

import http from "@/axios-config";

export async function tevalisClearCache() {
    await http.get("/api/tevalis/clear-cache");
}

export async function getTevalisSites() {
    const menuStore = useMenuInfoStore();

    const response = await http.get("/api/tevalis/get-sites");

    await menuStore.getMenuInfo();
}

export async function getTevalisMenuItems() {
    await http.get("/api/tevalis/get-menu-items");
}

export async function getTevalisMenuPrices() {
    await http.get("/api/tevalis/get-menu-prices");
}

export async function updateTevalis() {
    const appState = useAppState();

    appState.tevalisUpdating = true;

    http.get("/api/tevalis");

    return "done";
}
